<template>
  <div v-if="vehicle">
    <div class="enjoy">
      <div class="carName">{{ vehicle.vehicle_name }}</div>
      <div>
        {{ vehicle.encoded_vin }} &nbsp;&nbsp;|&nbsp;&nbsp;交车日期
        {{ addEightHour(vehicle.created_at, 'day') }}
      </div>
      <div class="username fvl"><van-icon name="contact" class="contact" />{{ vehicle.name }}</div>
      <div class="dealer">{{ vehicle.dealer.name }}</div>
      <div class="num">轮胎保障尊享服务（2）条轮胎）</div>
      <div v-if="vehicle.insurance">
        {{ vehicle.insurance.status_label }}&nbsp;&nbsp;|&nbsp;&nbsp;截止日期
        {{ addEightHour(vehicle.insurance.expired_at, 'day') }}
      </div>
      <div v-else>尚未领取</div>
      <div class="fc clauseBox">
        <div class="clause" @click="showCount += 1"><van-icon name="description" />&nbsp;服务条款</div>
        <div @click="compensationRecord"><van-icon name="balance-list" />&nbsp;补偿记录</div>
      </div>
    </div>
    <div class="tyre">
      <div class="fvlr mytyre">
        <div class="titel">我的轮胎</div>
        <div class="mimiSize">胎压正常</div>
      </div>
      <div class="fvlr tyreItem">
        <div v-for="(item, index) in vehicle.tyres" :key="item.id" class="item fvlr" @click="showPopUp(index)">
          <div class="fhlc">
            <p class="brand">{{ item.brand_cn }}</p>
            <p class="mimiSize">{{ item.spec }}</p>
          </div>
          <div>
            <img src="../../../assets/images/change.png" />
            <p class="mimiSize">{{ item.moe }}</p>
          </div>
        </div>
      </div>
    </div>
    <PopUp :showPopUp="showCount" :datas="clauseData">
      <Clause :dealer="vehicle.dealer" :vehicle="vehicle" />
    </PopUp>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { Dialog } from 'vant'
import PopUp from '@/components/common/PopUp'
import Clause from '@/views/customer/tyre/Clause'
import { clauseData } from '../../../assets/js/clauseData'
import { useRouter } from 'vue-router'
import { addEightHour } from '@/util/index'
import { setSession } from '@/util'
import { getVehicle } from '@/api/tyre'
export default {
  components: {
    PopUp,
    Clause
  },
  setup() {
    let router = useRouter()
    const state = reactive({
      showCount: 0,
      clauseData,
      vehicle: ''
    })
    const showPopUp = i => {
      Dialog.confirm({
        title: '申请使用轮胎保障尊享服务',
        message: '是否需要申请使用轮胎保障尊享服务？建议在经销商协助下完成轮胎保障尊享服务订单。',
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickOverlay: true
      })
        .then(() => {
          setSession('exclusiveVehicle', state.vehicle)
          router.push({
            path: '/createOrder',
            query: {
              from: 'exclusive',
              vehicleId: state.vehicle.id,
              tyreId: state.vehicle.tyres[i].tyre_id
            }
          })
        })
        .catch(() => {
          router.push({
            path: '/tyreDetail',
            query: {
              tyreId: 120,
              model: ''
            }
          })
        })
    }
    const compensationRecord = () => {
      router.push('/compensationRecord')
    }
    onMounted(async () => {
      let { vehicle } = await getVehicle()
      state.vehicle = vehicle
      setSession('exclusiveVehicle', vehicle)
    })
    return {
      ...toRefs(state),
      showPopUp,
      compensationRecord,
      addEightHour
    }
  }
}
</script>

<style lang="scss" scoped>
.enjoy {
  text-align: left;
  background: url('../../../assets/images/enjoyBg1.svg');
  background-size: cover;
  padding: 16px 20px;
  box-sizing: border-box;
  font-size: 12px;
  color: #666666;
  position: relative;
}
.carName {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px;
}
.username {
  font-size: 12px;
  color: #fff;
  position: absolute;
  right: 0;
  top: 13px;

  width: 70px;
  border-radius: 20px 0 0 20px;
  padding: 3px 5px;
  background-image: linear-gradient(#5ebde4, #3088c5);
  .contact {
    margin-right: 10px;
  }
}
.dealer {
  margin: 8px 0;
}
.num {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
  margin-top: 18px;
  margin: 8px 0;
}
.clause {
  margin-right: 100px;
}
.clauseBox {
  margin-top: 18px;
  div {
    display: flex;
    align-items: center;
  }
}
.tyre {
  padding: 18px 20px;
  box-sizing: border-box;
}
.titel {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}
.mytyre {
  margin-bottom: 22px;
}
.mimiSize {
  font-size: 12px;
  color: #999999;
}
.item {
  width: 125px;
  margin-bottom: 16px;
  img {
    width: 18px;
    height: 18px;
  }
  .brand {
    font-size: 14px;
    color: #333333;
  }
  .mimiSize {
    margin-top: 8px;
  }
}
.tyreItem {
  flex-wrap: wrap;
}
</style>
